export default __webpack_public_path__ + "feedback-960-612d8741c2ce957affe1d668dfdd8515.webp";